import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { RR_BATCH_TYPE } from '../../../common/enum/table/batch-type.enum';
import { RRICustomBatchOptionSettings } from '../../../common/interfaces/table/batch-options.interface';
import { RRTableBatchOptions } from '../../../common/interfaces/table/table-batch-options.interface';
import { RRBatchOption } from '../../../common/types/batch-option.type';

@Component({
  selector: 'rr-table-batch-options',
  templateUrl: './table-batch-options.component.html',
  styleUrls: ['./table-batch-options.component.scss'],
})
export class TableBatchOptionsComponent<T, R> implements OnInit, OnChanges {
  public BATCH_TYPE = RR_BATCH_TYPE;
  public renderableBatchOptions: RRBatchOption<T, R>[];

  @Input() showSelectAll: boolean;
  @Input() recordCount: number;
  @Input() showSelectColumn: boolean;
  @Input() clearBatchOptions: boolean;
  @Input() selectedRows: T[];
  @Input() visibleBatchOptions: RRTableBatchOptions<T, R>;
  @Output() batchOptionClicked: EventEmitter<RRBatchOption<T, R>> =
    new EventEmitter();
  @Output() batchOptionCleared: EventEmitter<void> = new EventEmitter();
  @Output() selectAllClicked: EventEmitter<void> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    if (this.visibleBatchOptions) {
      this.renderableBatchOptions = Object.values(
        this.visibleBatchOptions,
      ).filter((value) => {
        return (
          value.type != undefined &&
          Object.values(RR_BATCH_TYPE).includes(value.type)
        );
      });
    }
  }

  ngOnChanges(): void {
    if (this.clearBatchOptions === true) {
      this.selectedRows = [];
      this.batchOptionCleared.emit();
    }
  }

  public onBatchOptionClicked(batchOption: RRBatchOption<T, R>) {
    if (batchOption.type !== RR_BATCH_TYPE.CUSTOM) {
      this.batchOptionClicked.emit(batchOption);
    }
  }

  public onCustomBatchOptionClicked(
    option: RRICustomBatchOptionSettings<T>,
  ): void {
    this.batchOptionClicked.emit({
      type: RR_BATCH_TYPE.CUSTOM,
      title: '',
      settings: option,
    });
  }

  public getCustomBatchOptions(): RRICustomBatchOptionSettings<T>[] {
    if (
      this.visibleBatchOptions &&
      this.visibleBatchOptions.custom &&
      this.visibleBatchOptions.custom.settings &&
      Array.isArray(this.visibleBatchOptions.custom.settings)
    ) {
      return this.visibleBatchOptions.custom.settings;
    }
  }

  public onSelectAllClicked(): void {
    this.selectAllClicked.emit();
  }
}
